import classes from "./Section4.module.css";

export default function Section4() {
  return (
    <div className={classes.section4Wrapper}>
      <div className={classes.section4Container}>
        {cardsItem.map((item, index) => (
          <div key={index} className={classes.section4Content}>
            <div className={classes.section4Icon}>
              <img src={item.icon} alt={item.title} />
            </div>
            <div className={classes.section4Text}>
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const cardsItem = [
  {
    icon: "./img/home-img/section-4/shipping.svg",
    title: "Free Shipping",
    desc: "For all Orders Over $100",
  },
  {
    icon: "./img/home-img/section-4/return.svg",
    title: "30 Days Returns",
    desc: "For an Exchange Product",
  },
  {
    icon: "./img/home-img/section-4/secure.svg",
    title: "Secured Payment",
    desc: "Payment Cards Accepted",
  },
  {
    icon: "./img/home-img/section-4/gift.svg",
    title: "Special Gifts",
    desc: "Exclusive Gift Offers",
  },
  {
    icon: "./img/home-img/section-4/support.svg",
    title: "Support 24/7",
    desc: "Contact us Anytime",
  },
];
